export default {
  BusinessStockDistributionQty: {
    header: {
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      supportWarehouseCode: '供货仓编码',
      supportWarehouseName: '供货仓名称',
      categoryId: '商品分类',
      receiveWarehouseCode: '接收仓编码',
      receiveWarehouseName: '接收仓名称',
    },
    commodityDistribution: '商品分配',
    batchAllocation: '批量分配',

    table: {
      categoryName: '商品分类',
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      supportTypeCode: '供货仓类型',
      supportCode: '供货仓编码',
      supportName: '供货仓名称',
      qty: '仓位数量',
      receiveTypeCode: '接收仓类型',
      receiveCode: '接收仓编码',
      receiveName: '接收仓名称',
      lastUpdateName: '操作人员',
      lastUpdateDate: '操作时间'
    }
  }
};
